import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMerchantOrderSharedLinksForEventCountsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;


export type GetMerchantOrderSharedLinksForEventCountsQuery = { __typename?: 'Query', getMerchantOrderSharedLinksForEvent: { __typename?: 'GetMerchantOrderSharedLinksForEventResponse', total: number, eventMerchantorderSharedLinks: Array<{ __typename?: 'MerchantOrderSharedLink', id: string, event_account_id?: string | null, merchant_order_id?: string | null }> } };


export const GetMerchantOrderSharedLinksForEventCountsDocument = gql`
    query GetMerchantOrderSharedLinksForEventCounts($eventId: ID!) {
  getMerchantOrderSharedLinksForEvent(event_id: $eventId) {
    total
    eventMerchantorderSharedLinks {
      id
      event_account_id
      merchant_order_id
    }
  }
}
    `;

/**
 * __useGetMerchantOrderSharedLinksForEventCountsQuery__
 *
 * To run a query within a React component, call `useGetMerchantOrderSharedLinksForEventCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantOrderSharedLinksForEventCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantOrderSharedLinksForEventCountsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMerchantOrderSharedLinksForEventCountsQuery(baseOptions: Apollo.QueryHookOptions<GetMerchantOrderSharedLinksForEventCountsQuery, GetMerchantOrderSharedLinksForEventCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantOrderSharedLinksForEventCountsQuery, GetMerchantOrderSharedLinksForEventCountsQueryVariables>(GetMerchantOrderSharedLinksForEventCountsDocument, options);
      }
export function useGetMerchantOrderSharedLinksForEventCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantOrderSharedLinksForEventCountsQuery, GetMerchantOrderSharedLinksForEventCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantOrderSharedLinksForEventCountsQuery, GetMerchantOrderSharedLinksForEventCountsQueryVariables>(GetMerchantOrderSharedLinksForEventCountsDocument, options);
        }
export type GetMerchantOrderSharedLinksForEventCountsQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventCountsQuery>;
export type GetMerchantOrderSharedLinksForEventCountsLazyQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventCountsLazyQuery>;
export type GetMerchantOrderSharedLinksForEventCountsQueryResult = Apollo.QueryResult<GetMerchantOrderSharedLinksForEventCountsQuery, GetMerchantOrderSharedLinksForEventCountsQueryVariables>;